export default __webpack_public_path__ + "static/media/asana.3b942afc.png";